import { useTranslation } from "react-i18next";

const useSafeTranslation = (namespace?: string | string[]) => {
  const { t } = useTranslation(namespace);

  const safeT = (key: string, options?: any): object | object[] | string | string []=> {
    const result = t(key, options);
    const trimmedKey = typeof key === "string" ? key.split(":").slice(-1)[0] : null;

    if(trimmedKey === result) {
      throw new Error(`Failed to load text, missing key: ${key}, in: ${namespace}`);
    } else {
      return result;
    };
  };

  return {
    t: safeT,
  };
};
export default useSafeTranslation;
